import React from "react";
import { Col, Container, Row, Card, Table } from "react-bootstrap";
import { FaLock } from "react-icons/fa";
import { FaUser, FaUserLock } from "react-icons/fa6";
import { Link } from "react-router-dom";

const BlockedMember = () => {
  return (
    <>
      <Container fluid="lg" className="mt-5 pt-5">
        <Row className="margin_bottomfooter">
          <Col
            xs={12}
            className="d-flex align-items-center justify-content-between flex-wrap mb-4"
          >
            <h6 className="fs-3 fw-bold ">Account Settings</h6>
            <div className="unsaved_changes text-danger"></div>
            <div className="justify-content-between">
              <Link
                to="/profile/user"
                className="btn btn-info bg-blues mx-2 py-2 rounded-5"
              >
                View Profile
              </Link>
            </div>
          </Col>

          <Col xs={12} className="d-lg-none mb-4">
            <div className="itenary_tabs">
              <div className="card account-settingside sidebar_account safartabs">
                <div className="overflow-auto w-100 hide-scrollbar">
                  <div className="nav nav-tabs nav-pills card-body slider_accountsidebar d-flex gap-2 flex-nowrap">
                    <Link to="/account" className="nav-link link-nav">
                      <FaUser className="me-1" style={{ width: '2rem' }} />
                      Profile Settings
                    </Link>
                    <Link to="/account/privacy" className="nav-link link-nav">
                      <FaLock className="me-1" style={{ width: '2rem' }} />
                      Privacy
                    </Link>
                    <Link
                      to="/account/blocked-member"
                      className="nav-link link-nav active"
                    >
                      <FaUserLock className="me-1" style={{ width: '2rem' }} />
                      Blocked Members
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </Col>

          {/* Desktop Navbar */}
          <Col xxl={3} lg={4} className="d-none d-lg-block mb-4">
            <Card className="sidebar_account">
              <Card.Body className="nav nav-tabs flex-column nav-pills slider_accountsidebar">
                <Link to="/account" className="nav-link mb-2 ">
                  <FaUser className="me-2" />
                  Profile Settings
                </Link>
                <Link to="/account/privacy" className="nav-link mb-2 ">
                  <FaLock className="me-2" />
                  Privacy
                </Link>
                <Link
                  to="/account/blocked-member"
                  className="nav-link mb-2 active"
                >
                  <FaUserLock className="me-2" />
                  Blocked Members
                </Link>
              </Card.Body>
            </Card>
          </Col>

          <Col xxl={9} lg={8} className="itenary_tabs">
            <Card>
              <Card.Body className="p-4">
                <h6 className="fs-5 fw-bold mb-3"> Blocked User</h6>
                <div className="table-responsive table_design_manage">
                  <Table className="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default BlockedMember;
